import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-admin-deletion-request-created-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './admin-deletion-request-created.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailInfoboxComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class AdminDeletionRequestCreatedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<AdminDeletionRequestCreatedTemplateData>;
}

export type AdminDeletionRequestCreatedTemplateData = {
  header: string;
  title_html: string;
  note_body_html: string;
  footer: string;
  avatar_url: string;
  support_email: string;
};

export const AdminDeletionRequestCreatedTemplateMocks: AdminDeletionRequestCreatedTemplateData[] = [
  {
    header: 'Hi John 👋',
    title_html: 'You have just submitted a request to <b>delete the account</b>.',
    note_body_html:
      '<p>The <b>deletion of John Doe</b> account is now pending and the account has been locked. All user data will be <b>permanently deleted in 7 days</b>.</p>',
    footer:
      'If there are any problems with this deletion request, please contact our support team.',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    support_email: 'support@recruitee.com',
  },
];
